import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Agent, MinimalAgent} from '../models';
import {environment} from '../../environments';
import {map} from 'rxjs/operators';
import {PrismHeaders} from '../enums';

@Injectable({
    providedIn: 'root'
})
export class AgentService {
    private agentsTableSizePreference: number;

    constructor(private http: HttpClient) {
        this.agentsTableSizePreference = 10;

    }

    getAgents(
        sort: string,
        order: string,
        page: number,
        limit: number,
        status: string,
        search: string = ''): Observable<{ data: Agent[], availableItems: number }> {
        return this.http.get<{ data: Agent[], availableItems: number }>(environment.apiBaseUrl + '/member-get-agents', {
            params: {sort, order, page: page.toString(), limit: limit.toString(), status, search}
        });
    }

    get agentsTableSize() {
        return this.agentsTableSizePreference;
    }

    set updateAgentsTableSize(size: number) {
        this.agentsTableSizePreference = size;
    }

    getAgentNames(): Observable<MinimalAgent[]> {
        return this.http.get<{ data: MinimalAgent[] }>(environment.apiBaseUrl + '/member-get-agent-names').pipe(map(res => res.data));
    }

    postAgent(agent: Agent): Observable<string> {
        return this.http.post<{ ref: string }>(environment.apiBaseUrl + '/member-post-agent', agent).pipe(map(val => val.ref));
    }

    putAgent(agent: Agent): Observable<string> {
        return this.http.put<{ ref: string }>(environment.apiBaseUrl + '/member-put-agent', agent).pipe(map(val => val.ref));
    }

    getAgent(agentId: string): Observable<Agent> {
        const headers = new HttpHeaders()
            .append(PrismHeaders.QueryData, JSON.stringify({agentId: agentId}));
        return this.http.get<{ data: Agent }>(environment.apiBaseUrl + '/member-get-agent', {headers}).pipe(map(res => res.data));
    }

    updateAgentsActiveStatus(agentIds: string[], setActiveStatus: boolean) {
        const headers = new HttpHeaders()
            .append(PrismHeaders.FunctionHelperData, JSON.stringify({activeStatus: setActiveStatus}));

        return this.http.put(environment.apiBaseUrl + '/member-update-agents-active-status', {ids: JSON.stringify(agentIds)}, {headers});
    }
}
